<template>
    <Modal name="changeReport" v-bind="$attrs" :key='id' size="w-screen h-screen md:h-auto md:max-w-3xl md:w-6/12 md:rounded-3xl">
        <template v-slot:header>
            <h1>{{ $t('warning') }}</h1>
        </template>
        <template v-slot:body>
            <div class="grid grid-cols-1 sm:grid-cols-1 sm:gap-x-8">
              <p>{{ $t('change_report_warning') }}</p>
            </div>
        </template>
        <template v-slot:footer>
            <div class="btn btn-primary submit" @click="onReset">
                {{ $t('change_report') }}
            </div>
        </template>
    </Modal>
</template>

<script>
import { mapMutations } from 'vuex'
import Modal from '../modules/modals/components/Modal'

export default {
    name: 'modalChangeReport',
    components: {
        Modal,
    },
    methods: {
        ...mapMutations({
            setReportChoosingCollapsed: 'setReportChoosingCollapsed',
            reset: 'reset',
        }),
        onReset(){
          window.history.replaceState({}, '', `${location.pathname}`);
          this.reset()
          this.setReportChoosingCollapsed(false)
          window.onbeforeunload = null
          this.$attrs.close()
        },
    },
}
</script>

<style lang="sass" scoped>
h1
    font-size: 25px!important
</style>